var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('PhotographyIntroSection'),_c('PhotographyCastingSection'),_c('PhotographyStudioSection'),_c('PhotographyExternalSection'),_c('PhotographyFramingSection'),_c('PhotographyCollaboratorsSection'),_c('PhotographyCollaboratorsTwoSection'),_c('PhotographyWhatNoToDoSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }